module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "WevrWatermark.631d8fcc.svg";